import React from "react";
import { useParams } from "react-router-dom";
import BusinessAdsPageComponent from "../Component/BusinessAdsPage";
import Navbar from "../Component/Navbar";
import Footer from "../Component/Footer";

const BusinessAdsPage = () => {
  const { slug } = useParams();
  
  return (
    <div>
      <Navbar />
      <BusinessAdsPageComponent />
      <Footer />
    </div>
  );
};

export default BusinessAdsPage;